module.exports = require("ulid");